module.exports = __webpack_public_path__ + "static/img/5.5f15678.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/eng/5.png
// module id = F5vA
// module chunks = 0